module.exports = __webpack_public_path__ + "img/YangXu.9ec1e037.jpg";